import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from 'chart.js';

// Registering necessary components from Chart.js
ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const CountBarChart = ({ xLables }) => {
    const DATA_COUNT = 7;
    const NUMBER_CFG = { count: DATA_COUNT, min: 0, max: 100 };

    // Utility functions to generate data and labels
    const Utils = {
        months: ({ count }) => {
            const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            return months.slice(0, count);
        },
        numbers: ({ count, min, max }) => Array.from({ length: count }, () => Math.floor(Math.random() * (max - min + 1)) + min),
        CHART_COLORS: {
            black: '#2f3035',
            blue: '#5985fe'
        },
        transparentize: (color, opacity) => {
            const alpha = Math.round(opacity * 255);
            return `${color}${alpha?.toString(16).padStart(2, '0')}`;
        }
    };

    //   const name = xLables?.map(item => item.name) || [];
    //   const count = xLables?.map(item => item.count) || [];
    const name = Object?.keys(xLables); // ["John", "Jane", "Bob", "Alice"]
    const count = Object?.values(xLables);

    const alternatingColors = count?.map((_, index) =>
        index % 2 === 0 ? Utils.CHART_COLORS.black : Utils.CHART_COLORS.blue
    );
    const data = {
        labels: name,
        datasets: [
            {
                label: 'Counts',
                data: count,
                backgroundColor: alternatingColors,
                borderColor: alternatingColors,
                borderWidth: 2,
                borderRadius: 5,
            },
            // {
            //   label: 'Buyers',
            //   data: count,
            //   backgroundColor: Utils.CHART_COLORS.blue,
            //   borderColor: Utils.CHART_COLORS.blue,
            //   borderWidth: 2,
            //   borderRadius: 5,
            // }
        ]
    };
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: { beginAtZero: true },
            y: { beginAtZero: true }
        },
        // plugins: {
        //     legend: {
        //         display: false, // This hides the legend which contains the labels
        //         labels: {

        //             boxWidth: 20, // Set the width of the legend box; this will be square by default
        //             padding: 26,
        //         }
        //     },
        //     tooltip: {
        //         callbacks: {
        //             label: function () {
        //                 return ''; // This hides the tooltips labels
        //             }
        //         }
        //     }
        // }
    };

    return (
        <div style={{ height: "70vh", width: "100%" }}>
            <Bar data={data} options={options} />
        </div>
    );
};

export default CountBarChart;
